module.exports = __webpack_public_path__ + "static/media/michael-lowe-cv.0843b50d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/michael-lowe-cv.pdf
// module id = 75
// module chunks = 0